const state = {
  issue_ws: null,
  domain_ws: null,
  shadow_ws: null,
  websocketInstances: new Set(),
}

const mutations = {
  addWebSocketInstance(state, instance) {
    state.websocketInstances.add(instance)
  },
  removeWebSocketInstance(state, instance) {
    state.websocketInstances.delete(instance)
  },
}

const getters = {
  websocketInstances: state => state.websocketInstances,
}

export default {
  state,
  mutations,
  getters,
}
